function init () {
  const videoState = []

  document.addEventListener('videoManagement:player', (event) => {
    const data = event.detail
    videoState.push(data)
  })

  document.addEventListener('videoManagement:play', (event) => {
    const data = event.detail

    videoState.forEach(video => {
      if (video.element !== data.element) {
        video.element.dispatchEvent(new window.CustomEvent('video:pause'))
      }
    })
  })
}

init()